import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'header-bar',
  template: require('./header-bar.component.html'),
  styles: [require('./header-bar.component.css')]
})
export class HeaderBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    (<any>$('#headerCarousel .carousel')).carousel({
      interval: 3000,
      keyboard: true,
      // pause: 'hover',
      wrap: true
  });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/header-bar/header-bar.component.ts